import axios from "axios";

const endPoint = process.env.REACT_APP_API_ENDPOINT;

const endPoint2 = process.env.REACT_APP_API_SAP;

const courseEndPoint = process.env.REAT_APP_API_COURSE_FILTER;

export const progressStepsApi = async (data) => {
  const respose = await axios.get(`${endPoint}stagesRequest`, data);
  return respose;
};

export const profileApi = async (data) => {
  const respose = await axios.post(`${endPoint}profile`, data);
  return respose;
};

// Fetch Career Data
export const careerDataApi = async (data) => {
  try {
     const respose = await axios.get(`${endPoint2}get-course-carrers`, data);
     console.log("respose at 23", respose);
  return respose;
  } catch (error) {
    console.log("error at 25", error);
  }
 
};



// Fetch Course Data
export const courseDataApi = async (data) => {
  const respose = await axios.post(`${endPoint2}get-institute-courses`, data);
  return respose;
};

export const getInstituteCourses = async (page = 1, filters = {}) => {
  return await axios.post(
    `${endPoint2}get-institute-courses?page=${page}`,
    filters
  );
};

export const checkGivenQuiz = async (data) => {
  const respose = await axios.get(
    `${endPoint}quiz/check-personality-quiz-status`,
    data
  );
  return respose;
};
